module.exports = __webpack_public_path__ + "static/media/AccentGraphic.866b529d.png";